(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .factory('NumberUtils', NumberUtils);

  function NumberUtils() {
    return {
      truncate,
      lerp,
      clamp
    };

    function truncate(value, decimalPlaces) {
      const poweredTen = 10 ** decimalPlaces;
      return Math.floor(+value * poweredTen) / poweredTen;
    }

    function lerp(value, start, end) {
      return ((1 - value) * start) + (value * end);
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }
  }
}());
